import CumulativeToggleContainer from './containers/CumulativeToggleContainer';

export default CumulativeToggleContainer;
